import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { translate } from 'react-i18next';
import { Modal, Button, DropdownButton, MenuItem } from 'react-bootstrap';
import { getProfile } from '../../redux/profile/profile_actions';
import { logout } from '../../redux/authentication/authentication_actions';
import ProfileModal from '../../modal/account/ProfileModal';

import icon from '../../assets/images/user_male.png';

class Account extends React.Component {
  static profileDisplay(profile) {
    const { first_name, last_name, username } = profile || {
      first_name: '',
      last_name: '',
      username: 'anonymous',
    };

    const name = first_name.length > 0 || last_name.length > 0
      ? `${first_name} ${last_name}`
      : username;
    return name;
  }

  constructor(props) {
    super(props);

    this.state = {
      isShowLogoutDlg: false,
      isShowProfileModal: false,
    };
  }

  componentDidMount() {
    this.props.getProfile();
  }

  showProfileModal() {
    this.setState({ isShowProfileModal: true });
  }

  hideProfileModal() {
    this.setState({ isShowProfileModal: false });
  }

  showLogoutDlg() {
    this.setState({ isShowLogoutDlg: true });
  }

  hideLogoutDlg() {
    this.setState({ isShowLogoutDlg: false });
  }

  logout() {
    this.props.logout();
    this.hideLogoutDlg();
    this.props.history.push('/');
  }

  render() {
    const { t } = this.props;
    const buttonTitle = Account.profileDisplay(this.props.profile);

    return (
      <div className="user-menu">
        <span className="profile-picture">
          <img style={{ height: 30 }} src={icon} alt="Profile picture" />
        </span>
        <DropdownButton
          id="account-dropdown"
          bsStyle="large"
          title={buttonTitle}
          onSelect={key => {
            if (key === '1') {
              this.showProfileModal();
            } else if (key === '4') {
              this.showLogoutDlg();
            }
          }}
        >
          <MenuItem eventKey="1">{t('profile')}</MenuItem>
          <MenuItem divider />
          <MenuItem eventKey="4">{t('log out')}</MenuItem>
        </DropdownButton>
        <ProfileModal
          show={this.state.isShowProfileModal}
          onHide={() => this.hideProfileModal()}
        />
        <Modal
          show={this.state.isShowLogoutDlg}
          onHide={() => this.hideLogoutDlg()}
          container={this}
          aria-labelledby="contained-modal-title"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title">{t('log out')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{t('do you want to log out')}?</Modal.Body>
          <Modal.Footer>
            <Button onClick={() => this.logout()}>{t('log out')}</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: state.profile.isLoading,
  profile: state.profile.profile,
  errorMessage: state.profile.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  getProfile: () => dispatch(getProfile()),
  logout: () => dispatch(logout()),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withRouter(Account)),
);



// WEBPACK FOOTER //
// ./src/components/account/Account.js